<template>
  <div class="mobile_footer">
    <el-row class="footer_box">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item v-for="(section, idx) in sections" :key="idx" :title="section.title || ' '" :name="(idx + 1).toString()" v-show="section.title">
          <ul class="footer_link" v-if="section.items && section.items.length">
            <li v-for="(item, index) in section.items" :key="item.term + index">
              <router-link v-if="item.routeip && item.routeip.startsWith('/')" :to="item.routeip">{{ item.term }}</router-link>

              <a v-else-if="item.routeip && !item.routeip.startsWith('/')" :href="item.routeip" target="_blank" rel="noopener noreferrer">{{ item.term }}</a>

              <span v-else>{{ item.term }}</span>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>

      <!-- 二维码和 logo 及底部图标保持不变 -->
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="qr_code_img">
        <div class="qr_code_box">
          <!-- 你的二维码图片和说明 -->
        </div>
        <div class="qr_code_box">
          <!-- 你的二维码图片和说明 -->
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="footer_logo">
        <el-image src="https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/AiLifeLogonew.jpg" fit="fill" class="logo">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="footer_link_icon">
          <a v-for="(item, index) in footerIcon" :key="index" :href="item.link" target="_blank" rel="noopener noreferrer">
            <el-image :src="item.url" fit="fill" class="icon">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </a>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="copyright">
          Copyright &copy; 2020 AiLife Diagnostics. All rights reserved
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import picture from "@/utils/img";

export default {
  name: "mobile_footer",
  data() {
    return {
      activeName: "0",
      footerIcon: picture.footerIcon(),
      sections: picture.footerList(),
    };
  },
};
</script>

<style lang="scss">
/* 你的样式不变 */
.mobile_footer {
  .footer_box {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .title {
      width: 100%;
      color: #868788;
      font-size: 1.5rem;
      margin-bottom: 10px;
      text-align: center;
    }
    //二维码
    .qr_code_img {
      width: 100%;
      display: flex;
      justify-content: space-around;
      .qr_code_box {
        margin-top: 20px;
        .qr_code {
          width: 150px;
          height: 150px;
        }
        p {
          width: 150px;
          background: #ececec;
          font-size: 15px;
          text-align: center;
          height: 25px;
          line-height: 25px;
          position: relative;
          margin: 0 auto;
          .icon_po {
            position: absolute;
            top: -3px;
          }
        }
      }
    }

    //折叠
    .el-collapse {
      width: 100%;
      .el-collapse-item__header {
        font-size: 14px;
        background: $color_black;
        color: #ffffff;
        font-weight: 550;
        padding: 0 5px;
        border-bottom: 1px solid #707070;
      }
      .el-collapse-item__wrap {
        background: $color_black;
      }
      .footer_link {
        padding: 0 10px;
        & > li {
          a {
            font-size: 16px;
            line-height: 30px;
            display: inline-block;
            width: 100%;
            color: #ffffff;
          }
        }
        & > :nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
    //logo
    .footer_logo {
      display: flex;
      justify-content: center;
      margin: 20px 0 10px 0;
      .logo {
        width: 150px;
        height: 90px;
      }
    }

    //三个小图标
    .footer_link_icon {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .icon {
        width: 25px;
        height: 25px;
      }
      i {
        font-size: 30px;
      }
      a:nth-child(n + 2) {
        margin-left: 10px;
      }
    }
  }
  //注明
  .copyright {
    width: 100%;
    height: 50px;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/footer/footer.vue